export type TreeEntity = {
  value: string;
  parentValue?: string | null;
  checked: boolean;
};

export function findChildren<T extends TreeEntity>(entityValue: T['value'], entities: T[]) {
  return entities.filter(({ parentValue }) => parentValue === entityValue);
}

export function findParent<T extends TreeEntity>(entity: T, entities: T[]) {
  return entities.find(({ value }) => value === entity.parentValue);
}

/**
 * List of all entities down the tree, i. e. [child, child, grandchild, grandchild, ...]
 */
export function findDescendants<T extends TreeEntity>(entityValue: T['value'], entities: T[]): T[] {
  const children = findChildren(entityValue, entities);
  return [...children, ...children.flatMap((child) => findDescendants(child.value, entities))];
}

/**
 * Ancestors list, sorted going up by tree, i. e. [parent, grandparent, grandgrandparent, ...]
 */
export function findAncestors<T extends TreeEntity>(entity: T, entities: T[], acc: T[] = []): T[] {
  const parent = findParent(entity, entities);
  if (!parent) return acc;
  return findAncestors(parent, entities, [...acc, parent]);
}
